export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Poll-Notification-White-7c392fbe1172598f3079640c36e70be3.svg";